/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

angular.module('zeppelinWebApp').controller('LoginCtrl', LoginCtrl);

function LoginCtrl($scope, $rootScope, $http, $httpParamSerializer, baseUrlSrv, $location, $timeout) {
  'ngInject';

  $scope.loginParadigm = 'sso';
  $scope.showParadigmSwitch = false;
  $scope.SigningIn = false;
  $scope.loginParams = {
    userName: localStorage.getItem('magpie-username') === null ? '' : localStorage.getItem('magpie-username'),
    password: '',
  };
  $scope.passwordResetSuccessText = '';

  $scope.login = function() {
    localStorage.setItem('magpie-username', $scope.loginParams.userName);
    if ($scope.loginParadigm === 'password') {
      $scope.loginPassword();
    } else {
      $scope.loginSSO();
    }
  };

  $scope.loginPassword = function() {
    $scope.SigningIn = true;
    $http({
      method: 'POST',
      url: baseUrlSrv.getRestApiBase() + '/login',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: $httpParamSerializer({
        'userName': $scope.loginParams.userName,
        'password': $scope.loginParams.password,
      }),
    }).then(function successCallback(response) {
      $scope.passwordResetSuccessText = '';
      $rootScope.ticket = response.data.body;
      angular.element('#loginModal').modal('toggle');
      $rootScope.$broadcast('loginSuccess', true);
      $rootScope.userName = $scope.loginParams.userName;
      $scope.SigningIn = false;

      // redirect to the page from where the user originally was
      if ($location.search() && $location.search()['ref']) {
        $timeout(function() {
          let redirectLocation = $location.search()['ref'];
          $location.$$search = {};
          $location.path(redirectLocation);
        }, 100);
      } else {
        // redirect to home page
        $location.path('/');
      }
    }, function errorCallback(errorResponse) {
      $scope.passwordResetSuccessText = '';
      $scope.loginParams.errorText = 'The username and password that you entered don\'t match.';
      $scope.SigningIn = false;
    });
  };

  $scope.openPasswordReset = function() {
    angular.element('#loginModal').modal('toggle');
    angular.element('#sendPasswordResetModal').modal('toggle');
  };

  let initValues = function() {
    $scope.loginParams = {
      userName: localStorage.getItem('magpie-username') === null ? '' : localStorage.getItem('magpie-username'),
      password: '',
    };
  };

  // handle session logout message received from WebSocket
  $rootScope.$on('session_logout', function(event, data) {
    if ($rootScope.userName !== '') {
      $rootScope.userName = '';
      $rootScope.ticket = undefined;

      setTimeout(function() {
        $scope.loginParams = {
          userName: localStorage.getItem('magpie-username') === null ? '' : localStorage.getItem('magpie-username'),
          password: '',
        };
        $scope.loginParams.errorText = data.info;
        angular.element('.nav-login-btn').click();
      }, 1000);
      let locationPath = $location.path();
      $location.path('/').search('ref', locationPath);
    }
  });

  $rootScope.$on('passwordResetSuccess', function() {
    $scope.passwordResetSuccessText = 'Password successfully updated.';
  });

  $rootScope.$on('magpieConfig', function() {
    let paradigm = $rootScope.magpieConfig.zeppelin.loginParadigm;
    if(paradigm === 'both') {
      $scope.showParadigmSwitch = true;
      $scope.loginParadigm = 'sso';  // this will be the initial choice showing
    } else if (paradigm === 'sso') {
      $scope.loginParadigm = 'sso';
      $scope.showParadigmSwitch = false;
    } else {
      $scope.loginParadigm = 'password';
      $scope.showParadigmSwitch = false;
    }
  });
  /*
   ** $scope.$on functions below
   */
  $scope.$on('initLoginValues', function() {
    initValues();
  });

  $scope.loginSSO = function() {
    let ref = $location.$$absUrl;
    if ($location.$$url !== '/') {
      ref = ref.replace($location.$$url, '');
    }

    let domain = $scope.loginParams.userName.split('@')[1];
    if ($location.search() && $location.search()['ref']) {
      ref += $location.search()['ref'];
    }

    let url = baseUrlSrv.getRestApiBase() +
      '/login/sso?domain='+ domain +
      '&email=' + $scope.loginParams.userName +
      '&useHttps=' + $rootScope.magpieConfig.zeppelin.https +
      '&ref=' + encodeURIComponent(ref);

    window.location.href = url;
  };

  $scope.changeParadigm = function(p) {
    $scope.loginParadigm = p;
  };
}



// WEBPACK FOOTER //
// ./src/components/login/login.controller.js